import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

import './Spinner.pcss';

const Spinner = ({ overlayVisible, middle }) => {
  if (overlayVisible) {
    return (
      <React.StrictMode>
        <div className="service-spinner__overlay">
          <div className="service-spinner" />
        </div>
      </React.StrictMode>
    );
  }
  return (
    <React.StrictMode>
      <div className={cn('service-spinner_wrapper', { 'service-spinner__middle': middle })}>
        <div className="service-spinner" />
      </div>
    </React.StrictMode>
  );
};

Spinner.defaultProps = {
  middle: false,
  overlayVisible: false,
};

Spinner.propTypes = {
  middle: PropTypes.bool,
  overlayVisible: PropTypes.bool,
};

export default Spinner;
